import http from "../http-common";

class FamilyService {
  create(data) {
    return http.post("/families", data);
  }

  getAll() {
    return http.get("/families");
  }

  get(id) {
    return http.get(`/families/${id}`);
  }

  update(id, data) {
    return http.put(`/families/${id}`, data);
  }

  delete(id) {
    return http.delete(`/families/${id}`);
  }

  // Get femily member by family ID
  getFamilyMembers(familyId) {
    return http.get(`/families/${familyId}/members`);
  }

  // Get expenses by family ID
  getExpensesByFamilyId(familyId) {
    return http.get(`/families/${familyId}/expenses`);
  }

  // Get expenses by month, year and family ID
  getExpensesByMonthYearFamilyId(month, year, familyId) {
    return http.get(`/families/${familyId}/year/${year}/month/${month}/expenses`);
  }

  // Add user with username to family
  addUserToFamily(familyId, username) {
    return http.post(`/families/${familyId}/users`, { username });
  }

  // Add user with email to family
  addUserWithEmailToFamily(familyId, email) {
    return http.post(`/families/${familyId}/users/email`, { email });
  }

  // Add expense to family
  addExpenseToFamily(familyId, expenseData) {
    return http.post(`/families/${familyId}/expenses`, expenseData);
  }

  // Remove expense from family
  removeExpenseFromFamily(familyId, expenseId) {
    return http.delete(`/families/${familyId}/expenses/${expenseId}`);
  }

  // Remove user from family
  removeUserFromFamily(familyId, userId) {
    return http.delete(`/families/${familyId}/users/${userId}`);
  }

  // Get recurring expenses by family ID
  getRecurringExpensesByFamilyId(familyId) {
    return http.get(`/families/${familyId}/recurring-expenses`);
  }

  // Add recurring expense to family
  addRecurringExpenseToFamily(familyId, recurringExpenseData) {
    return http.post(`/families/${familyId}/recurring-expenses`, recurringExpenseData);
  }

  // Remove recurring expense from family
  removeRecurringExpenseFromFamily(familyId, recurringExpenseId) {
    return http.delete(`/families/${familyId}/recurring-expenses/${recurringExpenseId}`);
  }

  // Get overview notes by family ID
  getOverviewNotesByFamilyId(familyId) {
    return http.get(`/families/${familyId}/overview-notes`);
  }

  // Add overview note to family
  addOverviewNoteToFamily(familyId, overviewNoteData) {
    return http.post(`/families/${familyId}/overview-notes`, overviewNoteData);
  }

  // Set overview note paid status
  setOverviewNotePaidStatus(noteId, paid) {
    return http.put(`/overview-notes/setpaid/${noteId}/${paid}`);
  }

  // Get grocery items by family ID
  getGroceryItemsByFamilyId(familyId) {
    return http.get(`/families/${familyId}/grocery-items`);
  }

  // Add grocery item to family
  addGroceryItemToFamily(familyId, groceryItemData) {
    return http.post(`/families/${familyId}/grocery-items`, groceryItemData);
  }

  // Update grocery item in family
  updateGroceryItemInFamily(familyId, groceryItemId, groceryItemData) {
    return http.put(`/families/${familyId}/grocery-items/${groceryItemId}`, groceryItemData);
  }

  // Remove grocery item from family
  removeGroceryItemFromFamily(familyId, groceryItemId) {
    return http.delete(`/families/${familyId}/grocery-items/${groceryItemId}`);
  }

}

export default new FamilyService();
